/**
 * @generated SignedSource<<6d0735e2fea6f7ce532c5691ca483689>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Header$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"CreateButton" | "OpenTemplatesPanelButton">;
  } | null | undefined;
  readonly " $fragmentType": "Header";
};
export type Header$key = {
  readonly " $data"?: Header$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAnonymous"
    }
  ],
  "kind": "Fragment",
  "name": "Header",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "CreateButton"
        },
        {
          "condition": "isAnonymous",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "OpenTemplatesPanelButton"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "9c3b55bb49f474e13ecf93d84d059901";

export default node;
